import React, { useState, useEffect } from "react";
import axios from "axios";
const { getNewYorkDateTime } = require("../utils/dateUtils");
function VerifyForm({ currentUser }) {
  const [, setAgents] = useState([]);
  const [selectedAgent, setSelectedAgent] = useState(null);
  const [formData, setFormData] = useState({});
  const [showDialog, setShowDialog] = useState(false);
     const [leadSources, setLeadSources] = useState([]); // ✅ new state
 const [filteredAgents, setFilteredAgents] = useState([]);
     const [products, setProducts] = useState([]);
     const [selectedProducts, setSelectedProducts] = useState([]);
     const [filteredProducts, setFilteredProducts] = useState([]); // Products after validation

  const [campaigns, setCampaigns] = useState([]);



useEffect(() => {
  const fetchCampaigns = async () => {
    try {
      const res = await axios.get("https://crm-server-htk6.vercel.app/api/campaigns");

      console.log("Raw campaigns response:", res.data);

      // check if it's array or inside data property
      const campaignsData = Array.isArray(res.data) ? res.data : res.data.data;

      console.log("Parsed campaignsData:", campaignsData);

      // filter by isActive (boolean)
      const activeCampaigns = campaignsData.filter((c) => c.isActive);

      console.log("Active campaigns:", activeCampaigns);

      setCampaigns(activeCampaigns);
    } catch (err) {
      console.error("⚠️ Error fetching campaigns:", err);
    }
  };

  fetchCampaigns();
}, []);

     
useEffect(() => {
  const fetchProducts = async () => {
    try {
      const res = await axios.get("https://crm-server-htk6.vercel.app/api/products");

      // Filter only active products
      const activeProducts = res.data.filter(p => p.isActive === "Active");

      setProducts(activeProducts);
    } catch (err) {
      console.error("⚠️ Error fetching products:", err);
    }
  };
  fetchProducts();
}, []);



useEffect(() => {
  if (formData.product) {
    // Split by comma and trim spaces
    const initial = formData.product.split(",").map(p => p.trim());
    setSelectedProducts(initial);
  }
}, [formData.product]); // runs whenever formData.product changes

// const handleProductSelect = (productName) => {
//   let updatedProducts = [];

//   if (selectedProducts.includes(productName)) {
//     // Remove if already selected
//     updatedProducts = selectedProducts.filter(p => p !== productName);
//   } else {
//     // Add new selection
//     updatedProducts = [...selectedProducts, productName];
//   }

//   setSelectedProducts(updatedProducts);

//   // ✅ Sync with formData.product so it will save
//   setFormData(prev => ({
//     ...prev,
//     product: updatedProducts.join(", ")
//   }));
// };



const [blockedProducts, setBlockedProducts] = useState(new Set());

const handleProductSelect = async (productName) => {
  setLoading(true);
  let updatedSelected = [...selectedProducts];
  let updatedBlocked = new Set(blockedProducts);

  try {
    // Toggle select/deselect
    if (updatedSelected.includes(productName)) {
      // Deselect
      updatedSelected = updatedSelected.filter((p) => p !== productName);

      // Recalculate blocked products based on remaining selections
      let newBlocked = new Set();
      for (let pName of updatedSelected) {
        const prod = products.find((x) => x.productName === pName);
        if (prod) {
          const res = await axios.get(
            `https://crm-server-htk6.vercel.app/api/productRules/${prod._id}`
          );
          const rules = res.data;
          if (rules.productGroup?.length) {
            rules.productGroup.forEach((bp) => newBlocked.add(bp));
          }
        }
      }
      updatedBlocked = newBlocked;
    } else {
      // Select product
      updatedSelected.push(productName);

      // Fetch rule for selected product
      const selectedProd = products.find((x) => x.productName === productName);
      if (selectedProd) {
        const res = await axios.get(
          `https://crm-server-htk6.vercel.app/api/productRules/${selectedProd._id}`
        );
        const rules = res.data;

        // Add all group members to blocked set
        if (rules.productGroup?.length) {
          rules.productGroup.forEach((bp) => updatedBlocked.add(bp));
        }
      }
    }

    setSelectedProducts(updatedSelected);
    setBlockedProducts(updatedBlocked);
    setFormData((prev) => ({ ...prev, product: updatedSelected.join(", ") }));
  } catch (err) {
    console.error("Error in handleProductSelect:", err);
  } finally {
    setLoading(false);
  }
};




// ------^&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&     VALIDATE PRODUCT AFTER RULES APPLIED   %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%

    const [loading, setLoading] = useState(false);
   
  useEffect(() => {
    const validateProducts = async () => {
      try {
        setLoading(true);

        let validatedProducts = [...products];
        let blockedProducts = new Set();
        const centerName = currentUser?.center || "";

        // --- Product Mapping Validation ---
        // if (centerName && formData.leadSource && formData.campaign) {
        //   try {
        //     const mapRes = await axios.get(
        //       "https://crm-server-htk6.vercel.app/api/productMappings",
        //       {
        //         params: {
        //           center: centerName,
        //           leadSource: formData.leadSource,
        //           campaign: formData.campaign,
        //         },
        //       }
        //     );
        //     const mapping = mapRes.data;
        //     if (mapping && Array.isArray(mapping.products)) {
        //       validatedProducts = validatedProducts.filter(
        //         (p) => !mapping.products.includes(p.productName)
        //       );
        //     }
        //   } catch (mapErr) {
        //     console.error("Mapping error:", mapErr);
        //   }
        // }


        
                if (centerName && formData.leadSource && formData.campaign) {
          try {
            const mapRes = await axios.get(
              "https://crm-server-htk6.vercel.app/api/productMappings",
              {
                params: {
                  center: centerName,
                  leadSource: formData.leadSource,
                  campaign: formData.campaign,
                },
              }
            );
        
            const mapping = mapRes.data;
            if (mapping && Array.isArray(mapping.products)) {
              validatedProducts = validatedProducts.filter(
                (p) => mapping.products.includes(p.productName)
              );
            }
          } catch (mapErr) {
            console.error("Mapping error:", mapErr);
          }
        }



        // --- Per-product rules ---
        for (let product of [...validatedProducts]) {
          try {
            const res = await axios.get(
              `https://crm-server-htk6.vercel.app/api/productRules/${product._id}`
            );
            const rules = res.data;

            if (product.isActive !== "Active") {
              validatedProducts = validatedProducts.filter((p) => p._id !== product._id);
              continue;
            }

            if (rules.states?.includes(formData.state)) {
              validatedProducts = validatedProducts.filter((p) => p._id !== product._id);
              continue;
            }

            if (rules.cardTypes?.includes(formData.cardType)) {
              validatedProducts = validatedProducts.filter((p) => p._id !== product._id);
              continue;
            }

            // if (rules.productGroup?.length) {
            //   rules.productGroup.forEach((bp) => blockedProducts.add(bp));
            // }

            // BIN range
           if (formData.cardNumber && formData.cardNumber.length >= 6) {
  // 1️⃣ Remove hyphens or spaces
  const cleanCard = formData.cardNumber.replace(/[^0-9]/g, "");

  // 2️⃣ Extract first 6 digits
  const cardPrefix = cleanCard.substring(0, 6);

  try {
    const binRes = await axios.get(
      `https://crm-server-htk6.vercel.app/api/bins/${product.productName}`
    );

    const bins = binRes.data;

    // 3️⃣ Correct BIN comparison
    const isBlockedByBin = bins.some((bin) => {
      const start = Number(bin.StartRange);
      const end = Number(bin.EndRange);
      const prefix = Number(cardPrefix);
      return prefix >= start && prefix <= end;
    });

    if (isBlockedByBin) {
      validatedProducts = validatedProducts.filter(
        (p) => p._id !== product._id
      );

      // 👉 also store it in blockedProducts state
      setBlockedProducts((prev) => new Set([...prev, product.productName]));

      continue;
    }
  } catch (binErr) {
    console.error(`Bin error for ${product.productName}:`, binErr);
  }
}

          } catch (ruleErr) {
            console.error(`Rule error for ${product.productName}:`, ruleErr);
          }
        }

        // Remove blocked by productGroup
        validatedProducts = validatedProducts.filter(
          (p) => !blockedProducts.has(p.productName)
        );

        setFilteredProducts(validatedProducts);
      } catch (err) {
        console.error("Validation failed:", err);
      } finally {
        setLoading(false);
      }
    };

    // Run validation if at least one key input is set
    if (products.length) {
      validateProducts();
    }
  }, [
    products,
    formData.state,
    formData.cardType,
    formData.campaign,
    formData.leadSource,
    formData.cardNumber,
    currentUser
  ]);



 
  const states = ["AK","AL","AR","AZ","CA","CO","CT","DE","FL","GA","HI","IA","ID","IL","IN","KS","KY","LA","MA","MD","ME","MI","MN","MO","MS","MT","NC","ND","NE","NH","NJ","NM","NV","NY","OH","OK","OR","PA","RI","SC","SD","TN","TX","UT","VA","VT","WA","WI","WV","WY","GU",
"MP",
"PR",
"VI",
"DC"];

 // const states = ["AK","AL","AR","AZ","CA","CO","CT","DE","FL","GA","HI","IA","ID","IL","IN","KS","KY","LA","MA","MD","ME","MI","MN","MO","MS","MT","NC","ND","NE","NH","NJ","NM","NV","NY","OH","OK","OR","PA","RI","SC","SD","TN","TX","UT","VA","VT","WA","WI","WV","WY"];
  const houseTypes = ["Own","Rented"];
  const accountTypes = ["Checking","Savings"];
  
   // ✅ Fetch Lead Sources from backend on mount
  useEffect(() => {
    const fetchLeadSources = async () => {
      try {
        const res = await axios.get("https://crm-server-htk6.vercel.app/api/leadSources");
        setLeadSources(res.data);
      } catch (err) {
        console.error("⚠️ Error fetching lead sources:", err);
      }
    };
    fetchLeadSources();
  }, []);



//   const [loadingAgents, setLoadingAgents] = useState(false);   // For fetching data
// useEffect(() => {
//   const fetchAgents = async () => {
//     try {
//       setLoadingAgents(true); // ✅ show overlay while fetching

//       const agentsRes = await axios.get("https://crm-server-htk6.vercel.app/api/agents");
//       const allAgents = agentsRes.data || [];

//       // Today's date (ignore time)
//       const today = new Date();
//       today.setHours(0, 0, 0, 0);

//       const todayAgents = allAgents
//         .filter((agent) => {
//           // ✅ FIRST VALIDATION: Only same empCode & not verified
//         if (
//   agent.transferredVerifier?.empCode !== currentUser.empCode ||
//   agent.disposition?.trim() !== ""        // ❌ if disposition is NOT empty → return false
// ) {
//   return false;
// }


//           // ✅ SECOND VALIDATION: submitted today
//           if (
//             !agent.submittedDate ||
//             new Date(agent.submittedDate).setHours(0, 0, 0, 0) !== today.getTime()
//           ) {
//             return false;
//           }

//           return true;
//         })
//         .sort((a, b) => new Date(b.submittedDate) - new Date(a.submittedDate)); // latest first

//       setAgents(allAgents);          // ✅ store full list
//       setFilteredAgents(todayAgents); // ✅ show today's agents by default
//     } catch (err) {
//       console.error("Error fetching agents:", err);
//     } finally {
//       setLoadingAgents(false); // ✅ hide overlay when done
//     }
//   };

//   fetchAgents();
// }, [currentUser]);
const [loadingAgents, setLoadingAgents] = useState(false);


useEffect(() => {
  const fetchAgents = async () => {
    try {
      setLoadingAgents(true);

      const res = await axios.get(
        "https://crm-server-htk6.vercel.app/api/agents/today",
        { params: { empCode: currentUser.empCode } }
      );

      setFilteredAgents(res.data);
      setAgents(res.data); // if needed

    } catch (err) {
      console.error("Error fetching agents:", err);
    } finally {
      setLoadingAgents(false);
    }
  };

  if (currentUser?.empCode) {
    fetchAgents();
  }
}, [currentUser]);



  const handleAgentSelect = (agent) => {
    setSelectedAgent(agent);
    setFormData({
      ...agent,
      centerName: currentUser.center,
    //  agentName: `${agent.firstName} ${agent.lastName}`,
      verifName: currentUser.firstName,
      centerCode: currentUser.centerCode,
    });
    setShowDialog(true);
  };
const handleChange = (e) => {
  const { name, value, type } = e.target;

  // Skip uppercasing for date, numbers, and dropdowns
  if (type === "date" || type === "number" || e.target.tagName === "SELECT") {
    setFormData({ ...formData, [name]: value });
  } else {
    setFormData({ ...formData, [name]: value.toUpperCase() });
  }

  // ✅ If user deselects card type, clear card number
  if (name === "cardType" && value === "") {
    setFormData((prev) => ({ ...prev, cardNumber: "" }));
  }

  // ✅ If State or Card Type changes, reset Open Product and product list
  if (name === "state" || name === "cardType" || name === "campaign"  || name === "leadSource") {
    //setFormData((prev) => ({ ...prev, product: "" }));
    setFilteredProducts([]); // Clear validated product list
    setSelectedProducts([]); // Clear checked products
  }
};

 // DOB Validation
function validateDOB(dobValue) {
  if (!dobValue) {
    return { valid: false, message: "⚠️ Date of Birth is required!" };
  }

  // expecting YYYY-MM-DD
  const [year, month, day] = dobValue.split("-");
  const dob = new Date(year, month - 1, day);

  if (isNaN(dob.getTime())) {
    return { valid: false, message: "⚠️ Invalid Date of Birth format!" };
  }

  const today = new Date();
  let age = today.getFullYear() - dob.getFullYear();
  const m = today.getMonth() - dob.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < dob.getDate())) {
    age--;
  }

  if (age < 18) {
    return { valid: false, message: "⚠️ You must be at least 18 years old!" };
  }

  return { valid: true };
}

// Full Validation
 
// Full Validation
function validateForm(formData) {
  const mandatoryFields = [
    "firstName", "lastName", "gender", "phone", 
    "address", "city", "state", "zip", "campaign" , "leadSource" , "product" , "disposition" , "trackId" ,"verifCode" , "comments"
    
  ];


  // 👉 New rule for disposition = "Sale"
  if (formData.disposition === "Sale") {
    if (!formData.comments?.trim()) {
      return { valid: false, message: "⚠️ Comments are required for a Sale disposition." };
    }
    if (!formData.trackId?.trim()) {
      return { valid: false, message: "⚠️ Track ID is required for a Sale disposition." };
    }
    if (!formData.verifCode?.trim()) {
      return { valid: false, message: "⚠️ Verifier Code is required for a Sale disposition." };
    }
  }

  



  // Mandatory fields
  for (let field of mandatoryFields) {
    if (!formData[field] || formData[field].toString().trim() === "") {
      return { valid: false, message: `⚠️ ${field} is required!` };
    }
  }

  // Phone
  const phoneRegex = /^[2-9]\d{9}$/;
  if (!phoneRegex.test(formData.phone)) {
    return { valid: false, message: "⚠️ Phone must be 10 digits and cannot start with 0 or 1!" };
  }

  // Zip
  const zipRegex = /^\d{5}$/;
  if (!zipRegex.test(formData.zip)) {
    return { valid: false, message: "⚠️ Zip Code must be exactly 5 digits!" };
  }

  // DOB
  // ✅ Only validate if DOB is not empty
if (formData.dob) {
  const dobValidation = validateDOB(formData.dob);
  if (!dobValidation.valid) return dobValidation;
}


  // Alternate Phone
  if (formData.alternatePhone && !/^[2-9]\d{9}$/.test(formData.alternatePhone)) {
    return { valid: false, message: "⚠️ Alternate Phone must be 10 digits and cannot start with 0 or 1!" };
  }

  // Routing Number
  if (formData.routingNumber && !/^\d{9}$/.test(formData.routingNumber)) {
    return { valid: false, message: "⚠️ Routing Number must be 9 digits!" };
  }

  // ✅ Card Number Validation
if (formData.cardType) {
  const cardNum = formData.cardNumber;
  if (!cardNum) {
    return { valid: false, message: "⚠️ Please enter Card Number!" };
  }

  // ✅ Remove "-" for validation
  const cleanCardNum = cardNum.replace(/-/g, "");

  const rules = {
    Visa: {
      regex: /^4\d{15}$/, 
      hint: "Visa cards must start with 4 and be 16 digits long."
    },
    "Master Card": {
      regex: /^5\d{15}$/, 
      hint: "MasterCard must start with 5 and be 16 digits long."
    },
    Discover: {
      regex: /^6\d{15}$/, 
      hint: "Discover cards must start with 6 and be 16 digits long."
    },
    "American Express": {
      regex: /^3\d{14}$/, 
      hint: "American Express must start with 3 and be 15 digits long."
    }
  };

  const rule = rules[formData.cardType];

  // ✅ check card type support
  if (!rule) {
    return { valid: false, message: `⚠️ Unsupported Card Type: ${formData.cardType}` };
  }

  // ✅ apply validation on sanitized number
  if (!rule.regex.test(cleanCardNum)) {
    return { valid: false, message: `⚠️ ${rule.hint}` };
  }
}



  // CVV
  if (formData.cvv && !/^\d{3}$/.test(formData.cvv)) {
    return { valid: false, message: "⚠️ CVV must be 3 digits!" };
  }

  // Expiry
  if (formData.expiry && !/^(0[1-9]|1[0-2])\/\d{2}$/.test(formData.expiry)) {
    return { valid: false, message: "⚠️ Expiry must be in MM/YY format!" };
  }

  return { valid: true };
}

const handleNumericInput = (e) => {
  const re = /^[0-9\b]+$/; // only digits
  if (!re.test(e.key)) {
    e.preventDefault();
  }
};


  // 🔹 Update Agent
// 🔹 Update Agent
const handleUpdate = async () => {
  if (!formData || !formData._id) return;

  // ✅ Run Validation
  const validation = validateForm(formData);
  if (!validation.valid) {
    alert(validation.message);
    return; // stop update
  }
  

  try {
    // ✅ Add VerifiedDate to payload
    const payload = {
      ...formData,


verifiedDate: getNewYorkDateTime(),


    };
    delete payload._id;

    // ✅ Update Agent API
    const res = await axios.put(
      `https://crm-server-htk6.vercel.app/api/agents/${formData._id}`,
      payload
    );

    if (res.data.success) {
      alert("✅ Agent updated successfully");
      setShowDialog(false);

      // Update UI list with verifiedDate
      setAgents((prev) =>
        prev.map((a) =>
          a._id === formData._id
            ? { ...a, ...formData, verifiedDate: payload.verifiedDate }
            : a
        )
      );


      // ✅ Prepare log data
      const logData = {
        ...payload, // copy all agent fields
      //  logDate: new Date().toLocaleString("en-US", { timeZone: "America/New_York" }),
  
logDate: getNewYorkDateTime(),


        user: currentUser?.firstName || "",
        userCenter: currentUser?.center || "",
        userEmpCode: currentUser?.empCode || "",
        userRole: currentUser?.role || "",
        action: "Update", // mark this as update action
      };

      // ✅ Save log entry
      await axios.post("https://crm-server-htk6.vercel.app/api/logs", logData);
    } else {
      alert("❌ Failed to update agent");
    }
  } catch (err) {
    console.error("⚠️ Error updating agent:", err);
    alert("⚠️ Error updating agent");
  }
};


 // 🔹 Filter state
const [filters, setFilters] = useState({
  phone: "",      // ✅ Ensure this exists
  fromDate: "",
  toDate: ""
});
 // 🔹 Handle filter changes
  const handleFilterChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };


//   // 🔹 Apply filter when Go button pressed
// const applyFilters = () => {
//   // 🛑 Validate date range before filtering
//   if (!filters.fromDate || !filters.toDate) {
//     alert("⚠️ Please select both 'From' and 'To' dates before applying filters.");
//     return;
//   }

//   // 🧭 Logical order check
//   if (new Date(filters.fromDate) > new Date(filters.toDate)) {
//     alert("⚠️ 'From' date cannot be later than 'To' date.");
//     return;
//   }

//   let result = [...agents];

//   // ✅ Always enforce verifier filter
//   result = result.filter(
//     (a) =>
//       a.transferredVerifier?.empCode === currentUser.empCode &&
//       !a.verifiedDate
//   );

//   // 🔎 Phone filter
//   if (filters.phone?.trim()) {
//     const phoneFilter = filters.phone.trim();
//     result = result.filter((a) =>
//       (a.phone || "").includes(phoneFilter)
//     );
//   }

//   // 📅 Date range filter (normalize to date-only)
//   const from = new Date(filters.fromDate);
//   const to = new Date(filters.toDate);

//   // Make 'to' inclusive for same-day matches
//   to.setHours(23, 59, 59, 999);

//   result = result.filter((a) => {
//     if (!a.submittedDate) return false;
//     const submitted = new Date(a.submittedDate);
//     return submitted >= from && submitted <= to;
//   });

//   setFilteredAgents(result);
// };

const applyFilters = async () => {
  try {
    const params = {
      empCode: currentUser.empCode,
      phone: filters.phone || "",
      fromDate: filters.fromDate || "",
      toDate: filters.toDate || "",
    };

    const res = await axios.get(
      "https://crm-server-htk6.vercel.app/api/agents/filter1",
      { params }
    );

    setFilteredAgents(res.data.agents);

  } catch (err) {
    console.error("Filter error:", err);
    alert("Error fetching filtered agents");
  }
};


 


  // Dispositions dropdown
  const [dispositions, setDispositions] = useState([]);

  useEffect(() => {
    const fetchDispositions = async () => {
      try {
        const res = await axios.get("https://crm-server-htk6.vercel.app/api/dispositions");
        const active = res.data.filter((d) => d.isActive === "Active");
        setDispositions(active);
      } catch (err) {
        console.error("⚠️ Error fetching dispositions:", err);
      }
    };
    fetchDispositions();
  }, []);

  return (
    <div className="verify-container">


    {loadingAgents && (
  <div
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      background: "rgba(0,0,0,0.5)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 9999,
      color: "#fff",
      fontSize: "24px",
      fontWeight: "bold",
    }}
  >
    ⏳ Fetching Data...
  </div>
)}

      <h2>Assigned Forms</h2>
 {/* 🔹 Filter Bar */}
      <div className="filter-bar" style={{ marginBottom: "15px" }}>
        <input
          type="text"
          name="phone"
          placeholder="Search by Phone"
          value={filters.phone}
          onChange={handleFilterChange}
          style={{ marginRight: "10px" }}
        />
      <label>From:</label>
{/* <input
  type="date"
  name="fromDate"
  value={filters.fromDate}
  onChange={handleFilterChange}
  style={{ marginLeft: "5px", marginRight: "10px" }}
  min={new Date(
    new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toLocaleString("en-US", { timeZone: "America/New_York" })
  )
    .toISOString()
    .split("T")[0]}
  max={new Date(
    new Date().toLocaleString("en-US", { timeZone: "America/New_York" })
  )
    .toISOString()
    .split("T")[0]}
/> */}

<input
  type="date"
  name="fromDate"
  value={filters.fromDate}
  onChange={handleFilterChange}
  style={{ marginLeft: "5px", marginRight: "10px" }}
  min={new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)
    .toISOString()
    .split("T")[0]} // 7 days ago
  max={new Date()
    .toISOString()
    .split("T")[0]} // today
/>



        <label>To:</label>
        <input
          type="date"
          name="toDate"
          value={filters.toDate}
          onChange={handleFilterChange}
          style={{ marginLeft: "5px", marginRight: "10px" }}
        />
        <button onClick={applyFilters}>Go</button>
      </div>
      <div className="verify-agent-list-container">
         <table className="verify-agent-list-table">
          <thead>
            <tr>
              <th>CustomerID</th>
              <th>AGENT</th>
               <th>LEADSOURCE</th>
              <th>CUSTOMER NAME</th>
              <th>STATE</th>             
              <th>PHONE</th>
              <th>SUBMITTED DATE</th>
              {/* <th>Phone</th>
              <th>ADDRESS</th> */}
              
            </tr>
          </thead>
          <tbody>
            {filteredAgents.length === 0 ? (
              <tr>
                <td colSpan="7">No agents found.</td>
              </tr>
            ) : (
              filteredAgents.map((agent, index) => (
                <tr
                  key={agent._id}
                  onClick={() => handleAgentSelect(agent)}
                  className={
                    selectedAgent?._id === agent._id ? "verify-selected" : ""
                  }
                >
                  <td>{agent.CustomerID}</td>
                    <td>{agent.agentName}</td>
                     <td>{agent.leadSource}</td>
                    
                  <td>
                    {agent.firstName} {agent.lastName}
                  </td>
                   <td>{agent.state}</td>
                  <td>{agent.phone}</td>
                   <td>
                    {agent.submittedDate
                      }
                  </td>
                  {/* <td>{agent.phone}</td>
                  <td>{agent.address}</td> */}
                 
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {showDialog && selectedAgent && (
        <div className="verify-dialog-overlay">
          <div className="verify-dialog-box">
            <h2>Agent & Verification Details</h2>
            <div className="verify-dialog-content">

              <div className="verify-section verify-agent-section">
                <h3>Agent Details</h3>
                <form className="verify-crm-form">
                  {/* ROW 1 */}
                  <div className="verify-form-row">
                    <div className="verify-form-group">
                      <label>First Name *</label>
                      <input name="firstName" value={formData.firstName || ""} onChange={handleChange} />
                    </div>
                    <div className="verify-form-group">
                      <label>Last Name *</label>
                      <input name="lastName" value={formData.lastName || ""} onChange={handleChange} />
                    </div>
                  </div>

                  {/* ROW 2 */}
                  <div className="verify-form-row">
                    <div className="verify-form-group">
                      <label>Gender *</label>
                     <select name="gender" value={formData.gender} onChange={handleChange}>
            <option value="">Select</option>
            <option>Male</option>
            <option>Female</option>
            <option>Other</option>
          </select>
                    </div>
                    <div className="verify-form-group">
                      <label>Email</label>
                      <input name="email" value={formData.email || ""} onChange={handleChange} />
                    </div>
                  </div>

                  {/* ROW 3 */}
                  <div className="verify-form-row">
                    <div className="verify-form-group">
                      <label>Phone *</label>
                      <input name="phone"  maxLength={10} value={formData.phone || ""} onChange={handleChange} onKeyPress={handleNumericInput}/>
                    </div>
                    <div className="verify-form-group">
                      <label>Alternate Phone</label>
                      <input name="alternatePhone"  maxLength={10} value={formData.alternatePhone || ""} onChange={handleChange} onKeyPress={handleNumericInput} />
                    </div>
                  </div>

                  {/* ROW 4 */}
                  <div className="verify-form-row">
                    <div className="verify-form-group full-width">
                      <label>Address *</label>
                      <input name="address" value={formData.address || ""} onChange={handleChange} />
                    </div>

                
  <div className="verify-form-group full-width">
    <label>Address 2</label>
    <input 
      name="apt"
      value={formData.apt || ""} 
      onChange={handleChange} 
    />
  </div>
                    
                  </div>
      
                  {/* ROW 5 */}
                  <div className="verify-form-row">
                    <div className="verify-form-group">
                      <label>City *</label>
                      <input name="city" value={formData.city || ""} onChange={handleChange} />
                    </div>
                    <div className="verify-form-group">
                      <label>State *</label>
                     <select name="state" value={formData.state} onChange={handleChange}>
            <option value="">Select</option>
            {states.map((s) => (<option key={s} value={s}>{s}</option>))}
          </select>
                    </div>
                  </div>

                  {/* ROW 6 */}
                  <div className="verify-form-row">
                    <div className="verify-form-group">
                      <label>Zip Code *</label>
                      <input name="zip"  value={formData.zip || ""} onChange={handleChange}  onKeyPress={handleNumericInput}
  maxLength={5} />
                    </div>
                    <div className="verify-form-group">
                      <label>Date of Birth *</label>
                      <input type="date" name="dob" value={formData.dob || ""} onChange={handleChange} />
                    </div>
                  </div>

                  {/* ROW 7 */}
                  <div className="verify-form-row">
                    <div className="verify-form-group">
                      <label>House Type</label>
                     <select name="houseType" value={formData.houseType} onChange={handleChange}>
            <option value="">Select</option>
            {houseTypes.map((h) => (<option key={h} value={h}>{h}</option>))}
          </select>
                    </div>
                    <div className="verify-form-group">
                      <label>Account Number</label>
                      <input name="accountNumber" value={formData.accountNumber || ""} onChange={handleChange} />
                    </div>
                    <div className="verify-form-group">
                      <label>Bank Name</label>
                      <input name="bankName" value={formData.bankName || ""} onChange={handleChange} />
                    </div>
                  </div>

                  {/* ROW 8 */}
                  <div className="verify-form-row">
                    <div className="verify-form-group">
                      <label>Routing Number</label>
                      <input name="routingNumber" maxLength={9}  onKeyPress={handleNumericInput} value={formData.routingNumber || ""} onChange={handleChange} />
                    </div>
                    <div className="verify-form-group">
                      <label>Account Type</label>
                    <select name="accountType" value={formData.accountType} onChange={handleChange}>
            <option value="">Select</option>
            {accountTypes.map((a) => (<option key={a} value={a}>{a}</option>))}
          </select>
                    </div>


                     <div className="verify-form-group">
                      <label>Lead Source *</label>
                      <select
    name="leadSource"
    value={formData.leadSource}
    onChange={handleChange}
  >
    <option value="">-- Select Lead Source --</option>
    {leadSources.map((src) => (
      <option key={src._id} value={src.name}>
        {src.name}
      </option>
    ))}
  </select>

                    </div>
                  </div>

                  {/* ROW 9 */}
                  <div className="verify-form-row">
                    <div className="verify-form-group">
                      <label>Card Type</label>
                      {/* <input value={formData.cardType || ""} onChange={handleChange}/> */}
                    <select name="cardType" value={formData.cardType} onChange={handleChange}>
      <option value="">Select</option>
      <option>Visa</option>
      <option>Master Card</option>
      <option>American Express</option>
      <option>Discover</option>
    </select>
                    </div>
                    <div className="verify-form-group">
                     <label>Card Number</label>
<input
  name="cardNumber"
  value={
    (formData.cardNumber || "")
      .replace(/\D/g, "")                 // remove non-digits
      .replace(/(.{4})/g, "$1-")          // add `-` every 4 digits
      .replace(/-$/, "")                  // remove trailing `-`
  }
 onChange={handleChange}
  onKeyPress={handleNumericInput}
  disabled={!formData.cardType} // ✅ disables input until cardType is selected
  placeholder={!formData.cardType ? "Select Card Type first" : ""}
/>

                    </div>
                  </div>

                  {/* ROW 10 */}
                  <div className="verify-form-row">
                    <div className="verify-form-group">
                      <label>Expiry</label>
                      <input name="expiry" placeholder="MM/YY" value={formData.expiry || ""} onChange={handleChange}  />
                    </div>
                    <div className="verify-form-group">
                      <label>CVV</label>
                    <input name="cvv"  maxLength={formData.cardType === "American Express" ? 4 : 3} onChange={handleChange}   onKeyPress={handleNumericInput} 
          
             onPaste={(e) => e.preventDefault()}   // 🚫 block paste
    onCopy={(e) => e.preventDefault()}    // 🚫 block copy
    onCut={(e) => e.preventDefault()}     // 🚫 block cut
    style={{ imeMode: "disabled" }}       // 🚫 prevent IME auto input (extra layer)
          />
                    </div>
                  </div>

                  {/* ROW 11 */}
                  <div className="verify-form-row">
                    <div className="verify-form-group full-width">

                      <label>Products Sold *</label>
                      <textarea name="product" value={formData.product || ""}   readOnly />
                    </div>
                    {/* <div className="form-group full-width">
  <label>Select Products</label>
 <div
    className="product-list"
    style={{
      position: "relative",       // 👈 important so loader can absolutely position inside
      minHeight: "150px"          // optional, ensures space even while loading
    }}
  >

  {loading && (
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          background: "rgba(255,255,255,0.7)", // semi-transparent overlay (optional)
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "18px",
          fontWeight: "bold",
          color: "#333",
          zIndex: 10
        }}
      >
        ⏳ Validating products...
      </div>
    )}
   {filteredProducts.map((p) => (
      <label
        key={p._id}
        style={{ display: "block", marginBottom: "0.25rem" }}
      >
        <input
          type="checkbox"
          checked={selectedProducts.includes(p.productName)}
          onChange={() => handleProductSelect(p.productName)}
        />
        {" "}{p.productName}
      </label>
    ))}
  </div>
</div> */}



<div className="form-group full-width">
  <label>Select Products</label>

  <div
    className="product-list"
    style={{
      position: "relative",
      minHeight: "150px",
    }}
  >
    {loading && (
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          background: "rgba(255,255,255,0.7)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "18px",
          fontWeight: "bold",
          color: "#333",
          zIndex: 10,
        }}
      >
        ⏳ Validating products...
      </div>
    )}

    {/* 👇 Replace your old map() block with this one */}
    {filteredProducts.map((p) => {
      const isSelected = selectedProducts.includes(p.productName);
      const isBlocked = blockedProducts.has(p.productName);

      return (
        <label
          key={p._id}
          style={{
            display: "block",
            marginBottom: "0.25rem",
            opacity: isBlocked && !isSelected ? 0.5 : 1,
            cursor: isBlocked && !isSelected ? "not-allowed" : "pointer",
          }}
        >
          <input
            type="checkbox"
            checked={isSelected}
            disabled={isBlocked && !isSelected} // 🚫 block selection if product is in productGroup
            onChange={() => handleProductSelect(p.productName)}
          />
          {" "}{p.productName}
          {isBlocked && !isSelected && (
            <span style={{ color: "red", marginLeft: "5px" }}>(Blocked)</span>
          )}
        </label>
      );
    })}
  </div>
</div>

                  </div>

                  {/* ROW 12 Extra Verification Fields */}
                  <div className="verify-form-row">
                    <div className="verify-form-group">
                      <label>Verification Code</label>
                      <input name="verifCode" value={formData.verifCode || ""} onChange={handleChange} />
                    </div>
                    <div className="verify-form-group">
                      <label>Track ID *</label>
                      <input name="trackId" value={formData.trackId || ""} onChange={handleChange} />
                    </div>
                  </div>

                  {/* ROW 13 */}
                  <div className="verify-form-row">
                    <div className="verify-form-group">
                      <label>Center Name *</label>
                      <input name="centerName" value={formData.centerName || ""} readOnly />
                    </div>
                    <div className="verify-form-group">
                      <label>Agent Name *</label>
                      <input name="agentName" value={formData.agentName || ""} readOnly />
                    </div>
                  </div>

                  {/* ROW 14 */}
                  <div className="verify-form-row">
                    <div className="verify-form-group">
                      <label>Verifier Name *</label>
                      <input name="verifName" value={formData.verifName || ""} readOnly />
                    </div>
                    <div className="verify-form-group">
                      <label>Campaign *</label>
                      <select
                  name="campaign"
                  value={formData.campaign}
                  onChange={handleChange}
                >
                  <option value="">-- Select Campaign --</option>
                  {campaigns.map((c) => (
                    <option key={c._id} value={c.campaignName}>
                      {c.campaignName}
                    </option>
                  ))}
                </select>
                    </div>
                  </div>

                  {/* ROW 15 */}
                  <div className="verify-form-row">
                    <div className="verify-form-group full-width">
                      <label>Disposition *</label>
                      <select
                        name="disposition"
                        value={formData.disposition || ""}
                        onChange={handleChange}
                      >
                        <option value="">Select Disposition</option>
                        {dispositions.map(d => (
                          <option key={d._id} value={d.disposition}>{d.disposition}</option>
                        ))}
                      </select>
                    </div>
                  </div>

                  {/* ROW 16 */}
                  <div className="verify-form-row">
                    <div className="verify-form-group full-width">
                      <label>Comments</label>
                     <textarea
  name="comments"
  value={formData.comments || ""}
  onChange={(e) => {
    if (e.target.value.length <= 300) {
      handleChange(e); // ✅ only update if ≤ 300 chars
    }
  }}
  maxLength={300} // ✅ ensures user can't type beyond 300
  placeholder="Enter your comments (max 300 characters)"
  rows={4}
  style={{ width: "100%", resize: "vertical" }}
></textarea>

<p style={{ fontSize: "12px", color: "#555" }}>
  {formData.comments?.length || 0}/300 characters
</p>

                    </div>
                  </div>

                  {/* Buttons */}
                  <div className="verify-form-actions">
               
                    <button type="button" className="verify-btn-save" onClick={handleUpdate}>
                      Update
                    </button>
                    <button type="button" className="verify-btn-close" onClick={() => setShowDialog(false)}>
                      Close
                    </button>
                  </div>

                </form>
              </div>

            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default VerifyForm;
